module.exports = __webpack_public_path__ + "static/media/problem-solving-basic-hackerrank.62c4a0a1.png";